import { Component } from '@angular/core';
import { ModalChildComponent } from '@finder/shared/components/modal/modal-child-component.interface';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';
// eslint-disable-next-line max-len
import { DiningReservationsConflictModalService } from '@finder/features/list/services/dining-reservations-conflict-modal/dining-reservations-conflict-modal.service';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from '@finder/shared/components/button/button.component';
import { FontIconComponent } from '@finder/shared/components/font-icon/font-icon.component';

@Component({
    selector: 'finder-dining-reservations-conflict-modal',
    templateUrl: './dining-reservations-conflict-modal.component.html',
    styleUrls: ['./dining-reservations-conflict-modal.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ButtonComponent,
        FontIconComponent,
    ]
})
export class DiningReservationsConflictModalComponent implements ModalChildComponent {

    data: any;
    parentComponent: ModalComponent;

    get reservation() {
        return this.dininReservationsConflictData.reservationData;
    }

    get state() {
        return this.dininReservationsConflictData.flowState;
    }

    constructor(
        private dininReservationsConflictData: DiningReservationsConflictModalService
    ) { }

    back() {
        this.parentComponent.config.title = this.data.labels.title;
        this.dininReservationsConflictData.back();
    }

    keepReservation() {
        this.parentComponent.config.title = this.data.labels.keepTitle;
        this.dininReservationsConflictData.keepReservation();
    }

    cancelReservation() {
        this.parentComponent.config.title = this.data.labels.cancelTitle;
        this.dininReservationsConflictData.cancelReservation();
    }

    confirmCancel() {
        this.dininReservationsConflictData.confirmCancel();
        this.dismiss();
    }

    dismiss() {
        this.parentComponent.dismiss();
    }
}
